import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  forwardRef,
  SimpleChanges,
  EventEmitter,
  Output,
} from '@angular/core';

import {
  ControlValueAccessor,
  FormControl,
  FormsModule,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';

@Component({
  selector: 'rx-toggle',
  templateUrl: './rx-toggle.component.html',
  styleUrls: ['./rx-toggle.component.scss'],
  imports: [CommonModule, FormsModule, MatSlideToggleModule],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RxToggleComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RxToggleComponent),
      multi: true,
    },
  ],
})
export class RxToggleComponent implements ControlValueAccessor, Validator {
  @Input()
  public disabled = false;

  @Input()
  public label = '';

  @Input()
  public value;

  @Input()
  public id = 'item' + Math.random().toString(36).substring(2);

  @Output()
  public valueChange: EventEmitter<any> = new EventEmitter();

  public control: FormControl;

  public onChange = (value: string) => {};
  public onTouched = () => {};

  constructor() {}

  public changeChecked(event) {
    this.value = event.checked;
    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }

  // Register for change
  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  // Register for touch/click
  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Update the model and changes
  public writeValue(value: string): void {
    if (this.value !== value) {
      this.value = value;
      // this.onChange(this.value);
    }
  }

  public isValid(): boolean {
    return this.control && !this.control.pending && !this.control.errors && !this.control.invalid;
  }

  // validate
  public validate(control: FormControl): any {
    this.control = control;
    return control.valid ? null : control.errors;
  }
}
